import { ReactNode } from "react";

type ReviewSectionProps = {
  icon: ReactNode;
  title: string;
  onEdit?: () => void;
  skipped?: boolean;
  children?: ReactNode;
};

export function ReviewSection({
  icon,
  title,
  onEdit,
  skipped = false,
  children,
}: ReviewSectionProps) {
  if (skipped) {
    return (
      <div
        className="card mb-3"
        style={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#d9dfe5",
          borderRadius: "8px",
        }}
      >
        <div className="card-body" style={{ padding: "16px 20px" }}>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#dee2e6",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#52606d",
                  fontSize: "16px",
                }}
              >
                {icon}
              </div>
              <h3
                className="mb-0"
                style={{
                  color: "#52606d",
                  fontSize: "13px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {title}
              </h3>
            </div>
            <span
              className="fst-italic"
              style={{ fontSize: "13px", color: "#52606d" }}
            >
              This optional section has been skipped.
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="card mb-3"
      style={{
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#d9dfe5",
        borderRadius: "8px",
      }}
    >
      <div className="card-body" style={{ padding: "20px" }}>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <div
              className="review-section-icon"
              style={{
                width: "32px",
                height: "32px",
                backgroundColor: "#1e5a78",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontSize: "16px",
              }}
            >
              {icon}
            </div>
            <h3
              className="mb-0"
              style={{
                fontWeight: 600,
                fontSize: "13px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              {title}
            </h3>
          </div>
          {onEdit && (
            <button
              type="button"
              className="btn btn-link btn-sm text-decoration-none p-0"
              onClick={onEdit}
              aria-label={`Edit ${title}`}
              style={{ fontSize: "14px", color: "#1e5a78", fontWeight: 600 }}
            >
              <i className="bi bi-pencil me-1" aria-hidden="true"></i>
              Edit
            </button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}

type ReviewFieldProps = {
  label: string;
  value: string | number | null | undefined;
  fullWidth?: boolean;
};

export function ReviewField({
  label,
  value,
  fullWidth = false,
}: ReviewFieldProps) {
  const displayValue = value || "—";

  return (
    <div className={fullWidth ? "col-12 mb-3" : "col-md-4 mb-3"}>
      <div
        style={{
          fontSize: "12px",
          fontWeight: 400,
          color: "#52606d",
          marginBottom: "4px",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: 500,
          color: "#293038",
        }}
      >
        {displayValue}
      </div>
    </div>
  );
}
